import { WorklistNotificationFormType } from '../services/signalr-notifications.models';

export enum SearchFormType {
    ECG = 'ecg',
    VISIT = 'visit',
    COMPLETE_CD = 'complete_cd',
    ON_PRINTING_CD = 'on_printing_cd',
    TELEMONITORING = 'telemonitoring',
    COLLABORATION = 'collaboration',
    NRE = 'nre',
    DUMMY_VNEXT2 = 'dummy_vnext2',
    SPECIALTY = 'specialty',
    EXECUTION = 'execution',
    DIRECT_ADMISSION = 'direct_admission', //DA IMPLEMENTARE
    TOOLUPLOAD = 'toolupload'
}

export function fromWorklistNotification(type: WorklistNotificationFormType): SearchFormType | null {
    switch (type) {
        case WorklistNotificationFormType.Ecg:
            return SearchFormType.ECG;
        default:
            return null;
    }
}

export enum EstensaFormType {
    ECG_REPORTING = 'ecg_reporting',
    TELECONSULTATION = 'teleconsultation',
}

export interface IdDescriptionPair {
    id: any;
    description: string;
}
